import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaClipboardCheck, FaHandshake, FaCogs, FaShoppingCart, FaHardHat, FaTools, FaCheckCircle } from 'react-icons/fa';

const HowItWorks = () => {
  const [steps, setSteps] = useState([]);

  // --- ICON MAP (Database Strings -> React Components) ---
  const iconMap = {
    "FaClipboardCheck": <FaClipboardCheck />,
    "FaHandshake": <FaHandshake />,
    "FaCogs": <FaCogs />,
    "FaShoppingCart": <FaShoppingCart />,
    "FaHardHat": <FaHardHat />,
    "FaTools": <FaTools />
  };

  

  useEffect(() => {
    const fetchSteps = async () => {
      try {
       const res = await api.get('/ProcessSteps');
        if (res.data && res.data.length > 0) {
          setSteps(res.data);
        } else {
          // Fallback Data (Agar database empty ho ya API error ho)
          setSteps([
            { number: "01", iconName: "FaClipboardCheck", title: "Site Survey", description: "Detailed inspection...", duration: "0-7 days" },
            { number: "02", iconName: "FaHandshake", title: "Proposal", description: "Contract signing...", duration: "7-20 days" }
          ]);
        }
      } catch (err) {
        console.error("Error fetching process steps:", err);
      }
    };

    fetchSteps();
  }, []);

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        
        {/* Section Header */}
        <h2 className="section-title">Our Approach & Timeline</h2>
        <p className="section-subtitle">
          From site survey to long-term maintenance - a complete end-to-end solution
        </p>

        {/* Steps Container (Dynamic) */}
        <div className="steps-container">
          {steps.map((step, index) => (
            <div className="step-card" key={index}>
              <div className="step-number">{step.stepNumber}</div>
              
              <div className="step-icon-box" style={{ fontSize: '3rem', color: '#00D084', marginBottom: '1rem' }}>
                {/* Map String to Icon */}
                {iconMap[step.iconName] || <FaCheckCircle />}
              </div>
              
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              
              <div className="step-duration">
                <span className="badge bg-warning text-dark px-3 py-2">
                  <i className="bi bi-clock me-2"></i>
                  {step.duration}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Why Us Section (Static - As requested to keep design) */}
        <div className="row mt-5">
          <div className="col-lg-10 mx-auto">
            <div className="card border-0 shadow-lg" style={{ background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(10px)' }}>
              <div className="card-body p-5">
                <h3 className="text-center fw-bold mb-4 text-white">
                  Why Choose RENGIE's Approach?
                </h3>
                <div className="row text-white">
                  <div className="col-md-4 mb-3 mb-md-0 text-center">
                    <i className="bi bi-people-fill" style={{ fontSize: '3rem', color: '#00D084' }}></i>
                    <h5 className="mt-3 fw-semibold">Strong Technical Team</h5>
                    <p className="small mb-0 opacity-75">NIT & DTU qualified engineers</p>
                  </div>
                  <div className="col-md-4 mb-3 mb-md-0 text-center">
                    <i className="bi bi-gear-fill" style={{ fontSize: '3rem', color: '#00D084' }}></i>
                    <h5 className="mt-3 fw-semibold">Customized Systems</h5>
                    <p className="small mb-0 opacity-75">Designed for your specific needs</p>
                  </div>
                  <div className="col-md-4 text-center">
                    <i className="bi bi-award-fill" style={{ fontSize: '3rem', color: '#00D084' }}></i>
                    <h5 className="mt-3 fw-semibold">Best-in-Class Equipment</h5>
                    <p className="small mb-0 opacity-75">Latest technology & quality products</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .step-icon-box {
          transition: transform 0.3s ease;
        }
        
        .step-card:hover .step-icon-box {
          transform: scale(1.2) rotate(10deg);
        }
        
        .step-duration {
          margin-top: 1rem;
        }
      `}</style>
    </section>
  );
};

export default HowItWorks;